module.exports = __webpack_public_path__ + "img/AI-logo.cec618c8.png";